import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommunicationType } from './communication-type.interface';
import { CommunicationTypeService } from './communication-type.service';

const service = new CommunicationTypeService();

export interface CommunicationTypeState {
   communicationTypes: Array<CommunicationType>;
}

const CommunicationTypeStore: Module<CommunicationTypeState, StoreState> = {
   namespaced: true,
   state: { communicationTypes: [] },
   getters: { communicationTypes: (state) => state.communicationTypes },
   mutations: {
      SET_COMMUNICATION_TYPES(state, communicationTypes: Array<CommunicationType>) {
         state.communicationTypes = communicationTypes;
      },
   },
   actions: {
      async getCommunicationTypes(context, query: LocationQuery) {
         const response = await service.getCommunicationTypes(query);
         context.commit('SET_COMMUNICATION_TYPES', response.data);
         return response.data;
      },
   },
};

export default CommunicationTypeStore;
